export class GcpVmInstanceRestoreDestination {
    'gcpVm';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "gcpVm",
            "baseName": "gcpVm",
            "type": "GcpVmInstanceRestoreTarget",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpVmInstanceRestoreDestination.attributeTypeMap;
    }
    constructor() {
    }
}
